import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import { ErrorCard } from '@sm/webassets';
import { Typography } from '@wds/typography';

import appsAppListings from '../AppListingContext/AppListings.graphql';
import AppsGrid from '../AppsGrid';
import CategorySectionSkeleton from './CategorySectionSkeleton';
import { getCategoryFromKey } from '../../../../components/SearchContext/FilterOptions';

const CategorySection = ({ categoryKey, moreLink }) => {
  const [category, setCategory] = useState({});

  useEffect(() => {
    const cat = getCategoryFromKey(categoryKey);
    setCategory(cat);
  }, [categoryKey]);

  return (
    <Query query={appsAppListings} variables={{ categories: [1] }}>
      {({ loading, error, data }) => {
        return (
          <section className="sm-apps-grid">
            <header className="sm-apps-grid__header wds-flex wds-flex--between">
              <Typography component="div" variant="cardTitle">
                {category.name}
              </Typography>
              <If condition={moreLink}>
                <Typography>
                  {/* The query params need to be preserved between urls (needed for ut_source) */}
                  <a href={`${moreLink}`} className="sm-apps-grid__header-more-link">
                    See more
                  </a>
                </Typography>
              </If>
            </header>
            <Choose>
              <When condition={error}>
                <ErrorCard />
              </When>
              <When condition={loading}>
                <CategorySectionSkeleton data-testid="CategorySection__Skeleton" />
              </When>
              <Otherwise>
                <AppsGrid key={categoryKey} apps={data.fetchPublishedApplicationListings.data} />
              </Otherwise>
            </Choose>
          </section>
        );
      }}
    </Query>
  );
};

CategorySection.propTypes = {
  categoryKey: PropTypes.string,
  moreLink: PropTypes.string,
};

CategorySection.defaultProps = {
  categoryKey: 'featured',
  moreLink: '/apps/v2/featured',
};

export default CategorySection;
